const DebouncedScroll = 'DebouncedScroll',
    DebouncedResize = 'DebouncedResize',
    UserInfoLoaded = 'UserInfoLoaded',
    UserInfoReady = 'UserInfoReady',
    PageRendered = 'Page Rendered',
    OrderInfoLoaded = 'OrderInfoLoaded',
    OrderInfoReady = 'OrderInfoReady',
    DOMContentLoaded = 'DOMContentLoaded',
    CategoriesFetched = 'CategoriesFetched',
    CertonaLoaded = 'CertonaLoaded',
    CertonaReady = 'CertonaReady',
    CertonaFailed = 'CertonaFailed',
    Immediate = 'Immediate',
    ImmediateReady = 'ImmediateReady',
    VisitorAPILoaded = 'VisitorAPILoaded',
    TestTarget = 'TestTarget',
    TestTargetReady = 'TestTargetReady',
    TestTargetServiceReady = 'TestTargetServiceReady',
    TestTargetLoaded = 'TestTargetLoaded',
    TestTargetResult = 'TestTargetResult',
    UserInfoCtrlrsApplied = 'UserInfoCtrlrsApplied',
    OrderInfoCtrlrsApplied = 'OrderInfoCtrlrsApplied',
    CertonaCtrlrsApplied = 'CertonaCtrlrsApplied',
    TestTargetCtrlrsApplied = 'TestTargetCtrlrsApplied',
    InPageCompsCtrlrsApplied = 'InPageCompsCtrlrsApplied',
    LazyLoadComplete = 'LazyLoadComplete',
    ShowQuickLookModal = 'ShowQuickLookModal',
    ProfileUpdated = 'ProfileUpdated',
    load = 'load',
    PostLoad = 'PostLoad',
    PostLoadCtrlrsApplied = 'PostLoadCtrlrsApplied',
    SearchInfoLoaded = 'SearchInfoLoaded',
    SearchInfoReady = 'SearchInfoReady',
    ConstructorBeaconInitialized = 'ConstructorBeaconInitialized',
    ConstructorBeaconDisabled = 'ConstructorBeaconDisabled',
    CatalogEngineReady = 'CatalogEngineReady';

// This function should run immediately the first time its called.
// It will then run at the specified interval if called again
// before that interval is up.
function debounce(func, wait, immediate) {
    var lastRun,
        timeout,
        args,
        _this,
        later = function () {
            clearTimeout(timeout);
            timeout = null;
            lastRun = new Date().getTime();
            func.apply(_this, args);
        };

    return function () {
        /* eslint-disable no-invalid-this */
        _this = this;
        args = arguments;

        var sinceLastRun = new Date().getTime() - lastRun;
        if (sinceLastRun > wait) {
            later();
        } else if (!timeout) {
            timeout = setTimeout(later, wait - sinceLastRun);
        }
    };
}

var debouncedScrollHandler = debounce(function () {
    window.dispatchEvent(new CustomEvent(DebouncedScroll, { detail: {} }));
}, 50, true);

window.addEventListener('scroll', debouncedScrollHandler);

var debouncedResizeHandler = debounce(function () {
    window.dispatchEvent(new CustomEvent(DebouncedResize, { detail: {} }));
}, 500, true);

window.addEventListener('resize', debouncedResizeHandler);

var services = window.Sephora.Util.InflatorComps.services;

// const onLast = function (target, events, callback) {
//     var count = 0;
//
//     for (var i = 0; i < events.length; i++) {
//         target.addEventListener(events[i], function () {
//             if (++count === events.length) callback();
//         }, false);
//     }
// }

module.exports = {
    DebouncedScroll: DebouncedScroll,
    DebouncedResize: DebouncedResize,
    onLastLoadEvent: Sephora.Util.onLastLoadEvent,
    UserInfoLoaded: UserInfoLoaded,
    UserInfoReady: UserInfoReady,
    OrderInfoLoaded: OrderInfoLoaded,
    OrderInfoReady: OrderInfoReady,
    DOMContentLoaded: DOMContentLoaded,
    CategoriesFetched: CategoriesFetched,
    CertonaLoaded: CertonaLoaded,
    CertonaReady: CertonaReady,
    CertonaFailed: CertonaFailed,
    Immediate: Immediate,
    VisitorAPILoaded: VisitorAPILoaded,
    TestTarget: TestTarget,
    TestTargetServiceReady,
    TestTargetReady: TestTargetReady,
    TestTargetLoaded: TestTargetLoaded,
    TestTargetResult: TestTargetResult,
    UserInfoCtrlrsApplied: UserInfoCtrlrsApplied,
    OrderInfoCtrlrsApplied: OrderInfoCtrlrsApplied,
    CertonaCtrlrsApplied: CertonaCtrlrsApplied,
    TestTargetCtrlrsApplied: TestTargetCtrlrsApplied,
    InPageCompsCtrlrsApplied: InPageCompsCtrlrsApplied,
    LazyLoadComplete: LazyLoadComplete,
    ShowQuickLookModal: ShowQuickLookModal,
    load: load,
    ProfileUpdated: ProfileUpdated,
    PostLoad: PostLoad,
    PostLoadCtrlrsApplied: PostLoadCtrlrsApplied,
    SearchInfoLoaded,
    SearchInfoReady,
    ConstructorBeaconInitialized,
    ConstructorBeaconDisabled,
    CatalogEngineReady
};
